import { doc, setDoc, where } from 'firebase/firestore'
import { chunk } from 'lodash'

import FirestoreService from '../../firestoreService'
import FirebaseApp from '../../firebaseApp'

import { getConvertedData } from '../../../models/interface.helper'

import { UserModel } from '../../../models/users/user.model'
import { IUserInterface } from '../../../models/users/user.interface'

import { CONST } from '../../../const/const'

const COLLECTIONS = CONST.DATA.FIRESTORE.LATEST.COLLECTIONS

const getUserInfo = async (user: any) => {
  return FirestoreService.getItem(COLLECTIONS.USERS.NAME, user.uid)
}

const getUserById = async (id: string) => {
  const usersSnapShot = await FirestoreService.getItem(COLLECTIONS.USERS.NAME, id)
  return getConvertedData(UserModel.fromFirestoreDoc(usersSnapShot).toObject())
}

const getUserInfoById = async (id_to_use: any) => {
  return FirestoreService.getItem(CONST.DATA.FIRESTORE.LATEST.COLLECTIONS.USERS.NAME, id_to_use)
}

const getByIds = async (ids: string[]) => {
  const users: IUserInterface[] = []

  if (ids?.[0]) {
    const chunks = chunk(ids, 30) // Firestore limits the 'in' clause to 30 items

    const queries = chunks.map((idsChunk) =>
      FirestoreService.getItemsUsingIds(COLLECTIONS.USERS.NAME, idsChunk)
    )

    const snapshotsArray = await Promise.all(queries)

    snapshotsArray.forEach((snapshots) => {
      snapshots.forEach((doc) => {
        const current = getConvertedData(UserModel.fromFirestoreDoc(doc).toObject())
        users.push(current)
      })
    })
  }

  return users
}

const getUserDocumentDataByID = async (id_to_use: any) => {
  return FirestoreService.getItem(COLLECTIONS.USERS_DOCUMENTS.NAME, id_to_use)
}

const createCompetitorAccount = async (id_to_use: any, document: any) => {
  await setDoc(doc(FirebaseApp.firestore, COLLECTIONS.USERS_ACCOUNT.NAME, id_to_use), document)
}

const getCompetitorAccountDataByID = async (id_to_use: any) => {
  return FirestoreService.getItem(COLLECTIONS.USERS_ACCOUNT.NAME, id_to_use)
}

const getUserDocumentsDataByID = async (id_to_use: any) => {
  return FirestoreService.getItem(COLLECTIONS.USERS_DOCUMENTS.NAME, id_to_use)
}

const getByName = async (search: string) => {
  const users: IUserInterface[] = []

  const usersSnaps = await FirestoreService.filterItems(COLLECTIONS.USERS_PUBLIC.NAME, [
    where(COLLECTIONS.USERS_PUBLIC.FIELDS.USER_NAME_NGRAMS.KEY, 'array-contains', search),
  ])

  usersSnaps.forEach((currDoc) => {
    const current = getConvertedData(UserModel.fromFirestoreDoc(currDoc).toObject())
    users.push(current)
  })

  return users
}

const UserService = {
  getByIds,
  getUserInfo,
  getUserById,
  getUserInfoById,
  getUserDocumentDataByID,
  createCompetitorAccount,
  getCompetitorAccountDataByID,
  getUserDocumentsDataByID,
  getByName,
}

export default UserService
